import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable, of, switchMap, map } from 'rxjs';
import { DialogRevisionACComponent } from 'src/app/file/biblia/dialog-revisionAC/dialog-revisionAC.component';
import { PasajerosDialogComponent } from 'src/app/file/biblia/pasajeros-dialog/pasajeros-dialog.component';
import { VuelosDialogComponent } from 'src/app/file/biblia/vuelos-dialog/vuelos-dialog.component';
import { PreOperationalIncidentsDialogComponent } from 'src/features/file-detail/pre-operational-incidents/ui/pre-operational-incidents-dialog/pre-operational-incidents-dialog.component';
import { EnrichedProgrammingFile, FileProgrammingRepository } from 'src/entities/file';
import { FileStatesInfoComponent } from '../change-file-state/ui/file-states-info/file-states-info.component';

@Injectable({ providedIn: 'root' })
export class OpenFileReviewDialogsService {
  constructor(
    private readonly dialog: MatDialog,
    private readonly repository: FileProgrammingRepository
  ) {}

  openPassengers(file: EnrichedProgrammingFile): Observable<unknown> {
    const idItinerary = file?.id;
    const passengers$ = idItinerary
      ? this.repository
          .getSalesPassengersByItinerary(idItinerary)
          .pipe(map((response) => response?.getSalesPassengersByItinerary ?? []))
      : of([]);

    return passengers$.pipe(
      switchMap((passengers) =>
        this.dialog
          .open(PasajerosDialogComponent, {
            width: '96vw',
            maxWidth: '96vw',
            maxHeight: '90vh',
            data: {
              passengers,
              summary: {
                paxQuantity: file?.paxQuantity ?? 0,
                tcQuantity: file?.tcQuantity ?? 0
              }
            },
            panelClass: 'passengers-dialog-panel'
          })
          .afterClosed()
      )
    );
  }

  openFlights(fileId: string | null | undefined): Observable<unknown> {
    return this.dialog
      .open(VuelosDialogComponent, {
        width: 'min(1100px, 96vw)',
        height: 'min(680px, 88vh)',
        maxWidth: '96vw',
        maxHeight: '88vh',
        data: fileId,
        panelClass: 'flights-dialog-panel'
      })
      .afterClosed();
  }

  openFileStates(): Observable<unknown> {
    return this.dialog
      .open(FileStatesInfoComponent, {
        width: '980px',
        maxWidth: '96vw',
        maxHeight: '90vh'
      })
      .afterClosed();
  }

  openCsReview(file: EnrichedProgrammingFile): Observable<unknown> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '700px';
    dialogConfig.maxWidth = '95vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      itineraryId: file.id,
      activityId: undefined,
      activityDay: undefined,
      destination: undefined,
      activityName: undefined
    };

    return this.dialog.open(DialogRevisionACComponent, dialogConfig).afterClosed();
  }

  openPreOperationalIncidents(file: EnrichedProgrammingFile): Observable<unknown> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '700px';
    dialogConfig.maxWidth = '95vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.disableClose = true;
    dialogConfig.data = { itinerario: file };

    return this.dialog.open(PreOperationalIncidentsDialogComponent, dialogConfig).afterClosed();
  }
}
